import { useTranslation } from 'react-i18next';
import { colors } from '../theme/tokens';

export function ErrorFallback() {
  const { t } = useTranslation();

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: '#0f172a',
        color: '#e2e8f0',
        fontFamily: 'Manrope, system-ui, sans-serif',
        padding: '2rem',
        textAlign: 'center',
      }}
    >
      <h1 style={{ fontSize: '1.5rem', marginBottom: '0.75rem', color: colors.primary }}>
        {t('errorBoundary.title')}
      </h1>
      <p style={{ fontSize: '1rem', marginBottom: '1.5rem', maxWidth: '28rem', lineHeight: 1.6 }}>
        {t('errorBoundary.message')}
      </p>
      <button
        type="button"
        onClick={() => window.location.reload()}
        style={{
          padding: '0.625rem 1.5rem',
          fontSize: '0.875rem',
          fontWeight: 600,
          color: '#0f172a',
          backgroundColor: colors.primary,
          border: 'none',
          borderRadius: '0.5rem',
          cursor: 'pointer',
        }}
      >
        {t('errorBoundary.reload')}
      </button>
    </div>
  );
}
